import styled, { css } from 'styled-components';
import { Text } from 'grommet';
import GrommetTheme from '../../styles/GrommetTheme';

const TOP_HEIGHT = 50;
const MENU_ITEM_HEIGHT = 60;
const CARAT_WIDTH = 26;
const CARAT_OFFSET = 10;
const ACTIVE_COLOR = GrommetTheme.global.colors.brand;
const BORDER_COLOR = '#eee';

export const StyledDropdown = styled.div`
  background-color: #fff;
  position: relative;
  height: ${TOP_HEIGHT}px;
`;

export const StyledDropdownTop = styled.div`
  height: ${TOP_HEIGHT}px;
  padding: 10px;
  padding-right: ${CARAT_WIDTH + CARAT_OFFSET * 2}px;
  display: flex;
  align-items: center;
  /* border: solid 1px black; */
  cursor: pointer;
  z-index: 3;
  position: relative;
  > span {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  > svg {
    transition: transform 0.3s ease;
    position: absolute;
    width: ${CARAT_WIDTH}px;
    height: 15px;
    right: ${CARAT_OFFSET}px;

    /* Flipping the icon */
    ${({ isOpen }) => {
      if (isOpen) {
        return css`
          transform: rotate(180deg);
        `;
      }
      return css`
        transform: rotate(0deg);
      `;
    }}
  }
`;

export const StyledDropdownMenu = styled.div`
  top: ${TOP_HEIGHT}px;
  position: absolute;
  left: 0;
  right: 0;
  width: 100%;
  overflow: hidden;
  z-index: 4;
  transition: opacity 0.3s ease;
  box-shadow: 0px 4px 44px rgba(0, 0, 0, 0.25);

  ${({ isOpen }) => {
    if (isOpen) {
      return css`
        opacity: 1;
        height: auto;
      `;
    }

    return css`
      opacity: 0;
      height: 0px;
    `;
  }}
`;

export const StyledOptions = styled.div`
  background-color: #fff;
`;

export const StyledOption = styled.div`
  cursor: pointer;
  padding: 16px 20px;
  height: ${MENU_ITEM_HEIGHT}px;
  transition: background 0.3s ease, color 0.3s ease;

  &:not(:last-of-type) {
    border-bottom: solid 1px ${BORDER_COLOR};
  }

  /* Hover States */
  ${({ allowMultiple }) => {
    if (allowMultiple) {
      return css`
        &:hover {
          background: ${ACTIVE_COLOR};
          color: #fff;
          svg path {
            stroke: #000;
          }
        }
      `;
    }
    return css`
      &:hover {
        background: ${ACTIVE_COLOR};
        color: #fff;
      }
    `;
  }}

  // Active States
  ${({ allowMultiple, isActive }) => {
    // Multiple and Active
    if (allowMultiple && isActive) {
      return css`
        background: ${ACTIVE_COLOR};
        color: #fff;
        svg path {
          stroke: #000;
        }
      `;
    }

    // Single and Active
    if (!allowMultiple && isActive) {
      return css`
        background: ${ACTIVE_COLOR};
        color: #fff;
        svg path {
          stroke: #000;
        }
      `;
    }
  }}
`;

export const StyledOptionContent = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
`;
export const StyledOptionCount = styled(Text)`
  justify-self: end;
  flex: 0 0 auto;
`;
export const StyledOptionCheckbox = styled.div`
  flex: 0 0 auto;
  width: 20px;
  height: 20px;
  appearance: none;
  border-radius: none;
  border: solid 1px black;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const StyledOptionTitle = styled(Text)`
  padding-right: 20px;
  flex: 1 1 100%;
  display: inline-block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  ${StyledOptionCheckbox} + & {
    padding-left: 20px;
  }
`;
